import { Location } from '@angular/common';
import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { EUserType } from 'src/app/domain/enum/user-type';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    standalone: true,
    imports: [MatButtonModule]
})
export class LoginComponent implements OnInit, DoCheck {

    public IsPasswordVisible = false;

    constructor(
        private coreData: CoreData,
        private location: Location,
        private router: Router,
        private userService: UserService,
        private oauthService: OAuthService) { }

    ngOnInit() {
        this.doFAMSLogin();
    }

    ngDoCheck(): void {
        if (this.coreData.IsLoggedIn) {
            if (this.coreData.User?.Type === EUserType.Standard)
                this.router.navigate([ENavigationRoute.SampleList]);
            else
                this.router.navigate([ENavigationRoute.Home]);
        }
    }

    async doFAMSLogin() {

        this.oauthService.initCodeFlow();
    }

    async doFAMSLoginWithPassword() {

        this.oauthService.customQueryParams = {
            'prompt': 'login',
        };
        this.oauthService.initCodeFlow();
    }
}
